<div class="sidenav" fxLayout="column">
  <div class="sidenav-toolbar" fxLayout="row" fxLayoutAlign="start center">
    @if (!(expanded == false && collapsed == true)) {
      <div class="header padding" fxLayout="column"
        fxLayoutAlign="center center">
        <div class="fill-primary-contrast logo-container">
          <a routerLink="/"><img [src]="isRkon ? '../../../assets/images/rk-logo.png' : isDynamicLogoEnabled && logoUrl ? logoUrl : '../../../assets/images/atlogo.png'" class="dashboardlogo" alt=""></a>
        </div>
      </div>
    }

    @if (expanded == false && collapsed == true ) {
      <div class="header" fxLayout="column" fxLayoutAlign="center center">
        <div class="fill-primary-contrast">
          <img [src]="isRkon ? '../../../assets/images/rk-clogo.png' : '../../../assets/images/clogo.png'" class="dashboardlogo" style="width: 40px;" alt="">
        </div>
      </div>
    }
    <span fxFlex>
      <!-- fill space -->
    </span>
    <div fxFlexAlign="center" fxHide fxShow.gt-sm>
      <button (click)="toggleCollapsed()" class="sidenav-toolbar-collapse-toggle" mat-icon-button
        [matTooltip]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'" matTooltipPosition="right">
        <mat-icon class="sidenav-toolbar-collapse-icon">{{ collapsed ? 'menu' : 'menu_open' }}</mat-icon>
      </button>
    </div>
  </div>
  <fury-scrollbar class="sidenav-items" fxFlex="auto">
    @for (item of items$ | async; track (item.id || (item.name + '_' + (item.type || 'item') + '_' + (item.position ?? $index)))) {
      <fury-sidenav-item (isDeleted)="receiveMessage($event)" [item]="item" [level]="0"></fury-sidenav-item>
    }
  </fury-scrollbar>
</div>